<template>
  <card>
    <div v-if="$store.state.navs[$options.name]">
      <list
        :columns="columns"
        :modalCreate="modalCreate"
        :removeLink="removeLink"
        :cardLink="cardLink"
        :isUpdate="true"
        :isAdd="true"
        :itemLink="itemLink"
        :setLink="setLink"
        :fields="fields"
        :searchDisable="false"
        @change="change"
        v-model="val"
        @changeFunction="changeFunction"
      />
    </div>
  </card>
</template>
<script>
import List from "../components/List";

export default {
  name: "Deliveries",
  components: {
    List,
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      /**START ADD ITEM */
      val: [],
      modalCreate: "delivery",
      fields: [
        {
          key: "title",
          label: "Название",
          type: "field",
          textType: "text",
          isMultiLang: true,
        },
      ],
      /** APIs */
      removeLink: "deliveries/delete",
      cardLink: "delivery",
      itemLink: "deliveries/list",
      setLink: "deliveries/add",
      /** COLUMNS MODEL */
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "title",
          title: "Название",
          checkbox: true,
          full: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "is_active",
          title: "Автивен",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "price",
          title: "Цена",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "price_from",
          title: "Цена от",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "created_at",
          title: "Создан",
          checkbox: false,
          control: false,
          align: "right",
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
